import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Paper,
  InputAdornment,
  Tooltip,
  IconButton,
  Menu,
  CircularProgress,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  TableContainer,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import User_plus from "../../../shared/assets/icons/User_plus.jsx";
import DownloadIcon from "@mui/icons-material/Download";
import Styles from "../../../styles/vendorDashboard.module.css";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import AddIcon from "@mui/icons-material/Add";
import EditOutlined from "@mui/icons-material/EditOutlined";

import SearchIcon from "@mui/icons-material/Search";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CategoryIcon from "@mui/icons-material/Category";
import { useNavigate } from "react-router-dom";
import styles from "../../../styles/adminPortal.module.css";
import axios from "axios";
import FormatTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import Swal from "sweetalert2";
import { Close, FileDownload, FileDownloadOutlined } from "@mui/icons-material";

const getHeadCells = () => {
  const role = localStorage.getItem("role");

  return [
    { id: "poNumber", label: "PO Number", width: 100 },
    { id: "poDate", label: "PO Date", width: 150 },
    { id: "supplierDetails", label: "Supplier Details", width: 160 },
    { id: "shippingDetails", label: "Shipping Details", width: 200 },
    { id: "items", label: "No. Of Items", width: 150 },
    { id: "poAmount", label: "PO Amount", width: 150 },
    { id: "poStatus", label: "PO Status", width: 150 },
    { id: "amendment", label: "PO Amendment", width: 100 },
    { id: "poAssigned", label: "PO Assigned", width: 150 },
  ];
};

const PurchaseOrderTable = () => {
  const [headCells, setHeadCells] = useState(getHeadCells);
  const [allPOsList, setAllPOsList] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [isTotalPOs, setTotalPOs] = useState(0);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [excelLoading, setLoading] = useState(false);
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    phoneNumber: "",
    name: "",
  });
  const [poStatus, setPoStatus] = useState("Sent");

  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;

  const token = localStorage.getItem("token");
  const getPOQueryParams = ({
    pageValue = page,
    pageSizeValue = pageSize,
  } = {}) => {
    const params = new URLSearchParams();

    params.set("page", String(pageValue));
    params.set("limit", String(pageSizeValue));

    if (search.trim()) {
      params.set("search", search.trim());
    }

    if (poStatus) {
      params.set("status", poStatus);
    }

    Object.entries(searchInputs).forEach(([key, value]) => {
      if (value?.trim()) {
        params.set(key, value.trim());
      }
    });

    return params.toString();
  };

  const getAllPos = async (params) => {
    setDataLoading(true);

    try {
      const response = await axios.get(
        `${serverURL}/purchaseOrder/getAllPO?${params}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        setAllPOsList(response.data?.data || []);
        setTotalPages(response.data?.pagination?.totalPages || 0);
        setTotalPOs(response.data?.pagination?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching all POs:", error);
    } finally {
      setDataLoading(false);
    }
  };

  const fetchPOs = ({ pageValue = page, pageSizeValue = pageSize } = {}) => {
    const params = getPOQueryParams({
      pageValue,
      pageSizeValue,
    });

    getAllPos(params);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPOs({
        pageValue: 1,
        pageSizeValue: pageSize,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [search, poStatus]);
  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page
    if (search) {
      queryParams.append("search", search);
    }
    if (poStatus) {
      queryParams.append("status", poStatus);
    }

    // Page
    fetchPOs({
      pageValue: value,
      pageSizeValue: pageSize,
    });
  };
  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    // Page size
    fetchPOs({
      pageValue: 1,
      pageSizeValue: newSize,
    });
  };
  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };

  const widgetData = [
    {
      title: "Total PO",
      value: isTotalPOs,
      icon: <ReceiptLongIcon sx={{ color: "#1976d2" }} />,
    },
  ];

  const handleEdit = async (e, v) => {
    navigate("/adminportal/generatePO", {
      state: {
        poData: v,
        mode: "edit",
      },
    });
  };

  const handlePOApproval = async (poId, status) => {
    let rejectionReason = "";

    if (status === "Rejected") {
      const reasonResult = await Swal.fire({
        title: "Reject Purchase Order",
        text: "Please provide the reason for rejection.",
        input: "textarea",
        // inputLabel: "Rejection Reason",
        inputPlaceholder: "Enter rejection reason...",
        inputAttributes: {
          "aria-label": "Rejection Reason",
        },
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value.trim()) {
            return "Rejection reason is required.";
          }
        },
      });

      if (!reasonResult.isConfirmed) return;

      rejectionReason = reasonResult.value;
    }

    const result = await Swal.fire({
      title: `${status === "Accepted" ? "Approve" : "Reject"} Purchase Order?`,
      text:
        status === "Accepted"
          ? "This Purchase Order will be approved."
          : "This Purchase Order will be rejected.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: status === "Accepted" ? "#16a34a" : "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: status === "Accepted" ? "Yes, Approve" : "Yes, Reject",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${serverURL}/purchaseOrder/editPO/${poId}`,
        {
          poStatus: status,
          emailCheck: true,
          rejectionReason, // Only populated for rejection
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: `Purchase Order ${
          status === "Accepted" ? "approved" : "rejected"
        } successfully.`,
        timer: 1800,
        showConfirmButton: false,
      });

      getAllPos(`page=${page}&limit=${pageSize}`);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };
  const handleDelete = async (e, po) => {
    setAnchorEl(null);
    e.stopPropagation();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete PO "${po.poNumber}". This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      Swal.fire({
        title: "Deleting...",
        text: "Please wait while the Purchase Order is being deleted.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.delete(
        `${serverURL}/purchaseOrder/deletePO/${po._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.close();

      if (response.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: response.data.message || "Purchase Order deleted successfully.",
          timer: 2000,
          showConfirmButton: false,
        });

        // Refresh List
        getAllPos();
      }
    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while deleting the Purchase Order.",
      });
    }
  };

  const handleSyncPOs = async () => {
    try {
      setDataLoading(true);
      let response = await axios.get(
        `${serverURL}/purchaseOrder/getAllPOFromTranzact`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data?.success) {
        // Sync
        fetchPOs({
          pageValue: 1,
          pageSizeValue: pageSize,
        });
      }
    } catch (error) {
      console.error("error", error.response);
    } finally {
      setDataLoading(false);
    }
  };
  const handleViewPO = async (po) => {
    try {
      setDataLoading(true);
      let response = await axios.get(
        `${serverURL}/purchaseOrder/viewPOByPONumber`,
        {
          params: { poNumber: po?.po_number, documentId: po?.document_id },
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data?.success) {
        navigate("/adminportal/viewPO", {
          state: {
            poData: response?.data?.data || response?.data?.data?.detailedData,
            mode: "view",
            poStatus: po?.rawData?.document_status,
            pdfLink: response?.data?.pdfLink,
            poId: response?.data?.poId,
            vendorId: response?.data?.vendorId,
            campaignId: response?.data?.campaignId,
          },
        });
      }
    } catch (error) {
      console.error("error", error.response);
    } finally {
      setDataLoading(false);
    }
  };
  const handlePOReportsExcel = async () => {
    try {
      if (!fromDate || !toDate) {
        Swal.fire({
          icon: "warning",
          title: "Select Date Range",
          text: "Please select both From Date and To Date.",
        });

        return;
      }

      if (new Date(fromDate) > new Date(toDate)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Date Range",
          text: "From Date cannot be greater than To Date.",
        });

        return;
      }

      setLoading(true);

      const response = await axios.get(
        `${serverURL}/purchaseOrder/download-po-report`,
        {
          params: {
            fromDate,
            toDate,
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },

          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;

      link.download = `PO_Report_${fromDate}_to_${toDate}.xlsx`;

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PO report:", error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Unable to download PO report.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="h-[93vh] overflow-y-scroll ">
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 2,
          display: "flex",

          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          Purchase Order
        </Typography>

        <div className="flex justify-center items-center gap-3 flex-wrap">
          {/* Download Report Button */}
          <button
            type="button"
            onClick={() => setReportDialogOpen(true)}
            disabled={excelLoading}
            className={`
      group relative inline-flex items-center gap-2.5
      rounded-xl px-5 py-2
      text-sm font-semibold text-white
      shadow-lg shadow-blue-500/20
      transition-all duration-300 ease-out
      ${
        excelLoading
          ? "cursor-not-allowed bg-slate-400"
          : `
            bg-gradient-to-r from-[#1976d2] to-[#1565c0]
            hover:-translate-y-0.5
            hover:shadow-xl hover:shadow-blue-500/30
            active:translate-y-0
          `
      }
    `}
          >
            {excelLoading ? (
              <>
                <CircularProgress size={18} sx={{ color: "#fff" }} />
                <span>Generating...</span>
              </>
            ) : (
              <>
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15 transition-transform duration-300 group-hover:scale-110">
                  <FileDownloadOutlinedIcon fontSize="small" />
                </div>

                <span>Download Report</span>

                <span className="hidden sm:inline-block h-5 w-px bg-white/25" />

                <DateRangeIcon fontSize="small" className="opacity-80" />
              </>
            )}
          </button>

          {/* Sync Purchase Orders */}
          <Button
            variant="contained"
            onClick={handleSyncPOs}
            startIcon={<SyncIcon />}
            sx={{
              background: "linear-gradient(135deg, #1976d2, #1565c0)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "none",
              borderRadius: "12px",
              padding: "10px 20px",
              minHeight: "44px",
              boxShadow: "0 6px 18px rgba(25, 118, 210, 0.22)",
              transition: "all 0.25s ease",

              "&:hover": {
                background: "linear-gradient(135deg, #1565c0, #0d47a1)",
                boxShadow: "0 10px 25px rgba(25, 118, 210, 0.3)",
                transform: "translateY(-2px)",
              },

              "&:active": {
                transform: "translateY(0)",
              },
            }}
          >
            Sync Purchase Orders
          </Button>
        </div>
      </Paper>
      <Box p={3}>
        {/* Widgets */}

        <Grid container spacing={3} mb={4}>
          {widgetData.map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.title}>
              <Card elevation={2}>
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {item.title}
                      </Typography>

                      <Typography variant="h5" fontWeight={700}>
                        {item.value}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        background: "#E3F2FD",
                        borderRadius: "50%",
                        p: 1.5,
                      }}
                    >
                      {item.icon}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Filters */}

        <Paper
          elevation={0}
          sx={{
            mb: 3,
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            justifyContent: "space-between",
          }}
        >
          <div className="flex gap-3">
            <TextField
              size="small"
              className="w-[20rem] bg-white"
              placeholder="Search PO number, Supplier..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              select
              size="small"
              value={poStatus}
              onChange={(e) => {
                setPoStatus(e.target.value);
                setPage(1);
              }}
              sx={{
                width: 180,
                backgroundColor: "white",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                },
              }}
            >
              <MenuItem value="Sent">Approve</MenuItem>
              <MenuItem value="Draft">Draft</MenuItem>
              <MenuItem value="Cancelled">Cancelled</MenuItem>
              <MenuItem value="Amended">Amended</MenuItem>
            </TextField>

            {/* <TextField
              select
              className="bg-white"
              size="small"
              defaultValue=""
              sx={{ width: 180 }}
            >
              <MenuItem value="">Status</MenuItem>
            </TextField> */}
          </div>

          {/* <Button className="bg-white" variant="outlined" disabled>
            Create Batches
          </Button> */}
        </Paper>

        {/* Table */}

        <TableContainer
          className={`${styles.tableContainer} ${Styles["custom-scrollbar"]} `}
        >
          <Table stickyHeader className="rounded-lg ">
            <TableHead className={styles.tableHead}>
              <TableRow
                sx={{
                  backgroundColor: "#f7f7f7",
                }}
              >
                {headCells.map((headCell, index) => (
                  <TableCell
                    key={index}
                    className={styles.tableCell}
                    sx={{
                      minWidth: headCell.width,
                    }}
                  >
                    <span className={styles.headCellHeading}>
                      {" "}
                      {headCell.label}{" "}
                    </span>

                    <div className={styles.topBorderDiv}>
                      {["shippingDetails", "poNumber"].includes(
                        headCell[index]?.id,
                      ) ? (
                        <input
                          type="text"
                          className={styles.searchInput}
                          placeholder={`Search`}
                          //   onChange={(e) =>
                          //     // props.handleSearchChangeHead(e, headCell.id)
                          //   }
                          //   value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
                        />
                      ) : (
                        ""
                      )}

                      {/* )} */}
                    </div>
                  </TableCell>
                ))}
              </TableRow>

              {/* Filter Row */}
            </TableHead>
            {dataLoading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <div className="flex h-[400px] items-center justify-center">
                      <CircularProgress />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {allPOsList?.length > 0 ? (
                  <TableBody>
                    {allPOsList.map((v, index) => {
                      return (
                        <TableRow
                          hover
                          className={styles.tableRowHead}
                          tabIndex={-1}
                          onClick={() => {
                            handleViewPO(v, "view");
                            // handleViewClick(e, v._id, "read");

                            setSelectedRow(v);
                          }}
                          key={index}
                        >
                          {/* <TableCell
                              sx={{ maxWidth: "200px" }}
                              className={styles.tableRow}
                            >
                              <Checkbox />
                            </TableCell> */}
                          <TableCell
                            sx={{ maxWidth: "200px" }}
                            className={styles.tableRow}
                          >
                            <Tooltip title={v?.gstin} arrow placement="top">
                              <span
                                className={`${styles.truncateText} font-bold`}
                              >
                                {v?.rawData?.document_no_text || ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            sx={{ maxWidth: "160px" }}
                            className={styles.tableRow}
                          >
                            <span className={styles.truncateText}>
                              {(
                                <FormatTimestamp
                                  timestamp={v?.rawData?.creation_date}
                                />
                              ) || "Not Available"}
                            </span>
                          </TableCell>
                          <TableCell
                            sx={{ maxWidth: "200px" }}
                            className={styles.tableRow}
                          >
                            <Tooltip
                              title={
                                v?.rawData?.supplier_name || "Not Available"
                              }
                              arrow
                              placement="top"
                            >
                              <span
                                className={`${styles.truncateText} font-[400]`}
                              >
                                {v?.rawData?.supplier_name || "Not Available"}
                              </span>
                              <span
                                className={`${styles.truncateText} font-bold `}
                              >
                                {v?.rawData?.supplier_gstin || "Not Available"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            sx={{ maxWidth: "200px" }}
                            className={styles.tableRow}
                          >
                            <Tooltip
                              title={
                                v?.rawData?.customer_delivery_location ||
                                "Not Available"
                              }
                              arrow
                              placement="top"
                            >
                              <span className={styles.truncateText}>
                                {v?.rawData?.customer_delivery_location_name ||
                                  "Not Available"}
                              </span>
                              <span className={styles.truncateText}>
                                {v?.rawData?.customer_delivery_location ||
                                  "Not Available"}
                              </span>
                            </Tooltip>
                          </TableCell>

                          {/* <TableCell className={styles.tableRow}>
                            {v?.locations?.slice(0, 3).join(", ")}

                            {v?.locations?.length > 3 && (
                              <Tooltip
                                title={v?.locations.slice(3).join(", ")}
                                arrow
                              >
                                <span className="ml-1 cursor-pointer font-medium text-blue-600">
                                  +{v?.locations.length - 3} more
                                </span>
                              </Tooltip>
                            )}
                          </TableCell> */}
                          {/* <TableCell className={styles.tableRow}>
                            {v?.productItems?.length > 0 && (
                              <div className="flex items-center gap-1 flex-wrap">
                                {v.productItems
                                  .slice(0, 4)
                                  .map((item, index) => (
                                    <span key={index}>
                                      {item.productName}
                                      {index <
                                        Math.min(
                                          3,
                                          v.productItems.length - 1,
                                        ) && ", "}
                                    </span>
                                  ))}

                                {v.productItems.length > 4 && (
                                  <span
                                    title={v.productItems
                                      .slice(4)
                                      .map((item) => item.productName)
                                      .join(", ")}
                                    className="cursor-pointer text-blue-600 font-medium"
                                  >
                                    +{v.productItems.length - 4} more
                                  </span>
                                )}
                              </div>
                            )}
                          </TableCell> */}

                          <TableCell className={`${styles.tableRow}`}>
                            <span
                              className={`${styles.truncateText}  font-bold text-center`}
                            >
                              {v?.rawData?.no_of_items}
                            </span>
                          </TableCell>
                          <TableCell className={styles.tableRow}>
                            <span className={styles.truncateText}>
                              ₹ {v?.rawData?.grand_total?.toFixed(2)}
                            </span>
                          </TableCell>
                          <TableCell className={styles.tableRow}>
                            <span
                              className={`rounded-full px-3 py-1 text-sm font-medium ${
                                v?.rawData?.document_status === "Draft"
                                  ? "bg-cyan-100 text-cyan-700"
                                  : v?.rawData?.document_status === "Amended"
                                    ? "bg-lime-100 text-green-600"
                                    : v?.rawData?.document_status === "Sent"
                                      ? "bg-emerald-100 text-emerald-700"
                                      : v?.rawData?.document_status ===
                                          "Cancelled"
                                        ? "bg-red-100 text-red-600"
                                        : "bg-gray-100 text-gray-600"
                              }`}
                            >
                              {v?.rawData?.document_status == "Sent"
                                ? "Approve"
                                : v?.rawData?.document_status}
                            </span>
                          </TableCell>
                          <TableCell className={styles.tableRow}>
                            <span
                              className={`${styles.truncateText}  font-bold text-center`}
                            >
                              {v?.rawData?.amendment}
                            </span>
                          </TableCell>
                          <TableCell className={styles.tableRow}>
                            <span>{v?.vendorId ? " Yes" : "No"}</span>
                          </TableCell>

                          {/* <TableCell
                            className={styles.tableRow}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex justify-center">
                              <Tooltip title="Click">
                                <IconButton
                                  onClick={(e) => handleIconOpen(e, v._id)}
                                >
                                  <MoreVertIcon
                                    style={{
                                      color: "var(--primary-color)",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </div>
                            <Menu
                              anchorEl={anchorEl}
                              onClose={handleIconClose}
                              keepMounted
                              open={
                                Boolean(anchorEl) && selectedRowId === v._id
                              }
                            >
                              <MenuItem
                                disabled={v?.poStatus === "Accepted"}
                                onClick={(e) => handleEdit(e, v)}
                              >
                                <EditOutlined style={{ color: "#6b7280" }} />{" "}
                                <p className="ml-2 font-semibold text-[#6b7280]">
                                  Edit
                                </p>
                              </MenuItem>
                              {v.poStatus != "Accepted" && (
                                <MenuItem onClick={(e) => handleDelete(e, v)}>
                                  <DeleteOutline style={{ color: "red" }} />{" "}
                                  <p className="ml-2 font-semibold text-[red]">
                                    Delete
                                  </p>
                                </MenuItem>
                              )}
                            </Menu>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={headCells?.length}
                      sx={{ borderBottom: "none" }}
                    >
                      <div className="flex justify-center items-center h-64">
                        No Data Found.
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        <div className="flex items-center justify-between ">
          <FormControl
            variant="standard"
            size="small"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              "& .MuiInputBase-root:before": { borderBottom: "none" },
              "& .MuiInputBase-root:after": { borderBottom: "none" },
              "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
            }}
          >
            <InputLabel
              id="page-size-label"
              sx={{
                position: "static",
                transform: "none",
                fontSize: "14px",
                marginRight: "8px",
                marginTop: "2px",
              }}
            >
              Rows
            </InputLabel>

            <Select
              labelId="page-size-label"
              value={pageSize}
              onChange={handlePageSizeChange}
              variant="standard"
              disableUnderline
            >
              {pageSizeOptions.map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Pagination
            className="p-2 flex justify-center"
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            sx={{
              "& .MuiPaginationItem-root.Mui-selected": {
                backgroundColor: "#418cff", // Blue background for selected
                color: "#fff", // White text for selected
              },
              "& .MuiPaginationItem-root.Mui-selected:hover": {
                backgroundColor: "#3366cc", // Darker blue on hover
              },
              "& .MuiPaginationItem-root": {
                "&:hover": {
                  backgroundColor: "#ddd", // Light gray for hovered items
                },
              },
            }}
          />
        </div>
      </Box>
      {
        <Dialog
          open={reportDialogOpen}
          onClose={() => {
            if (!excelLoading) {
              setReportDialogOpen(false);
            }
          }}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
            },
          }}
        >
          {/* Header */}
          <DialogTitle
            sx={{
              padding: "20px 24px",
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              color: "#fff",
            }}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15">
                  <FileDownloadOutlinedIcon />
                </div>

                <div>
                  <div className="text-base font-semibold">
                    Download PO Report
                  </div>

                  <div className="text-xs font-normal text-blue-100 mt-0.5">
                    Select the date range for your report
                  </div>
                </div>
              </div>

              <IconButton
                onClick={() => setReportDialogOpen(false)}
                disabled={excelLoading}
                sx={{
                  color: "#fff",
                  backgroundColor: "rgba(255,255,255,0.1)",

                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.2)",
                  },
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            </div>
          </DialogTitle>

          {/* Content */}
          <DialogContent sx={{ padding: "28px 24px 20px" }}>
            <div className="flex flex-col gap-5 mt-2">
              {/* Info */}
              <div className="flex items-start gap-3 rounded-xl bg-blue-50 border border-blue-100 p-3">
                <DateRangeIcon
                  sx={{
                    color: "#1976d2",
                    fontSize: 22,
                    marginTop: "2px",
                  }}
                />

                <div>
                  <p className="text-xs text-slate-500 mt-1">
                    The Excel report will contain purchase orders created within
                    the selected date range.
                  </p>
                </div>
              </div>

              {/* From Date */}
              <TextField
                label="From Date"
                type="date"
                fullWidth
                size="small"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                disabled={excelLoading}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <DateRangeIcon
                      sx={{
                        color: "#1976d2",
                        marginRight: "10px",
                        fontSize: 20,
                      }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                }}
              />

              {/* To Date */}
              <TextField
                label="To Date"
                type="date"
                fullWidth
                size="small"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                disabled={excelLoading}
                inputProps={{
                  min: fromDate || undefined,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <DateRangeIcon
                      sx={{
                        color: "#1976d2",
                        marginRight: "10px",
                        fontSize: 20,
                      }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                }}
              />
            </div>
          </DialogContent>

          {/* Actions */}
          <DialogActions
            sx={{
              padding: "8px 24px 24px",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => setReportDialogOpen(false)}
              disabled={excelLoading}
              sx={{
                textTransform: "none",
                color: "#64748b",
                fontWeight: 600,
                borderRadius: "10px",
                padding: "9px 18px",
              }}
            >
              Cancel
            </Button>

            <Button
              onClick={handlePOReportsExcel}
              disabled={!fromDate || !toDate || excelLoading}
              variant="contained"
              startIcon={
                excelLoading ? (
                  <CircularProgress size={17} sx={{ color: "#fff" }} />
                ) : (
                  <FileDownloadOutlinedIcon />
                )
              }
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "10px",
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1976d2, #1565c0)",
                boxShadow: "0 6px 16px rgba(25,118,210,0.25)",

                "&:hover": {
                  background: "linear-gradient(135deg, #1565c0, #0d47a1)",
                  boxShadow: "0 8px 20px rgba(25,118,210,0.35)",
                },

                "&.Mui-disabled": {
                  background: "#e2e8f0",
                  color: "#94a3b8",
                },
              }}
            >
              {excelLoading ? "Generating..." : "Download Excel"}
            </Button>
          </DialogActions>
        </Dialog>
      }
    </div>
  );
};

export default PurchaseOrderTable;
